'use strict';

import React from 'react';
import { browserHistory } from 'react-router';
import MediaStore from 'stores/MediaStore';
import MediaActions from 'actions/MediaActions';
import UserStore from 'stores/UserStore';
import API from 'sources/API';

import 'styles/Publish.scss';

class PublishComponent extends React.Component {
  constructor(props) {
    super(props);
    let categories = MediaStore.getState().categoryList;
    this.state = {
      categories: categories,
      step: 1,
      type: 0,  // 暂时类型都是text
      countryTab: 'foreign',
      images: [],
      localImages: [],
      desc: '',
      title: '',
      reviews: '',
      rating: 0,
      price_level: 0,
      url: '',
      vicinity: '',
      website: '',
      formatted_address: '',
      hidden_url: '',
      hidden_desc: '',
      name: '',
      lat: 0,
      lng: 0,
      place_id: '',
      viewport: {},
      bounds: {},
      types: {},
      from: '',
      city_id: null,
      city_name: '',
      cities: [],
      locations: [],
      category_id: '',
      price: 1,
      inputTimeout: null,
      priceInputRevealShow: false,
      additionInfoRevealShow: false,
      isOtherPrice: false,
      handleSubmiting: false,
      errorMsg: ''
    };
    this.changeCountryTabInner = this.changeCountryTabInner.bind(this);
    this.changeCountryTabForeign = this.changeCountryTabForeign.bind(this);
    this.onCategoryClick = this.onCategoryClick.bind(this);
    this.goStep2 = this.goStep2.bind(this);
    this.goStep1 = this.goStep1.bind(this);
    this.postMedia = this.postMedia.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.picUpload = this.picUpload.bind(this);
    this.wechatPicUpload = this.wechatPicUpload.bind(this);
    this.onCityFocus = this.onCityFocus.bind(this);
    this.onLocationFocus = this.onLocationFocus.bind(this);
    this.onCityInputChange = this.onCityInputChange.bind(this);
    this.onLocationInputChange = this.onLocationInputChange.bind(this);
    this.pickCity = this.pickCity.bind(this);
    this.pickLocation = this.pickLocation.bind(this);
    this.onFromChange = this.onFromChange.bind(this);
    this.togglePriceInputReveal = this.togglePriceInputReveal.bind(this);
    this.toggleAdditionInputReveal = this.toggleAdditionInputReveal.bind(this);
    this.onPriceInput = this.onPriceInput.bind(this);
    this.toggleErrorMsgReveal = this.toggleErrorMsgReveal.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
    this.removePicture = this.removePicture.bind(this);
  }
  componentDidMount() {
    MediaStore.listen(this.onMediaChange);
    MediaActions.fetchCategories();
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }
    // goole anlaytics
    window.ga('set', 'page', this.props.location.pathname);
    window.ga('send', 'pageview');
  }
  componentWillUnmount() {
    MediaStore.unlisten(this.onMediaChange);
  }
  changeCountryTabInner() {
    this.setState({countryTab: 'inner'});
  }
  changeCountryTabForeign() {
    this.setState({countryTab: 'foreign'});
  }
  onCategoryClick(catId, event) {
    let active = event.target.parentNode.querySelector('.active');
    if(active) {
      active.className = 'columns small-4 button';
    }
    event.target.className = `${event.target.className} active`;
    this.setState({category_id: catId});
  }
  goStep2() {
    window.scrollTo(0,0);
    this.setState({step: 2});
  }
  goStep1() {
    window.scrollTo(0,0);
    this.setState({step: 1});
  }
  onPriceClick(price, event) {
    event.target.className = `${event.target.className} active`;
    this.setState({price: price, isOtherPrice: false});
  }
  onPriceInput(e) {
    this.setState({price: e.target.value, isOtherPrice: true});
  }
  onMediaChange(media) {
    this.setState({
      categories: media.categoryList,
      errorMsg: media.errorMsg,
      handleSubmiting: false
    });
  }
  removePicture(img) {
    this.setState((previousState)=>{
      let index = previousState.localImages.indexOf(img);
      previousState.localImages.splice(index,1);
      previousState.images.splice(index,1);
      return {
        images: previousState.images,
        localImages: previousState.localImages
      };
    });
  }
  picUpload(event) {
    let index = this.state.localImages.length;
    if(index >= 9) {
      alert('最多选9张图片');
      return;
    }
    for(var i = 0; i < event.target.files.length && i+index <= 8; i++) {
      let img = event.target.files[i];
      let reader = new FileReader();
      let that = this;
      let currentIndex = index + i;
      reader.readAsDataURL(img);
      reader.onload = function(e) {
        that.setState((previousState)=>{
          previousState.localImages[currentIndex] = {
            url: e.target.result,
            uploading: true
          };
          return {
            localImages: previousState.localImages
          };
        });
      }
      let formData = new FormData();
      formData.append('file', img);
      fetch(`${API.imageUpload}`, {
        method: 'POST',
        body: formData
      }).then(res=>res.json())
      .then(json=>{
        if(json.status === 0) {
          window.scrollTo(0, document.body.scrollHeight); // 滚屏到底部
          this.setState((previousState)=>{
            previousState.images[currentIndex] = json.url;
            previousState.localImages[currentIndex].uploading = false;
            return {
              images: previousState.images,
              localImages: previousState.localImages
            };
          });
        }
      });
    }
  }
  wechatPicUpload(event){
    event.preventDefault();
    let index = this.state.localImages.length;
    let that = this;
    let syncUpload = (localIds,currentIndex) => {
      let localId = localIds.pop();
      wx.uploadImage({
        localId: localId,
        isShowProgressTips: 1,
        success: function (res) {
          let serverId = res.serverId; // 返回图片的服务器端ID
          fetch(`${API.wechatImageUpload}`,{
            method: 'POST',
            body: JSON.stringify({media_id:serverId}),
            headers: API.jsonHeader
          }).then(res=>res.json())
          .then(json=>{
            if(json.status === 0){
              window.scrollTo(0, document.body.scrollHeight); // 滚屏到底部
              that.setState((previousState)=>{
                previousState.images[currentIndex] = json.url;
                return {
                  images: previousState.images
                }; 
              });
            }
          });

          if(localIds.length > 0){
            syncUpload(localIds,currentIndex-1);
          }
        }
      });
    };
    wx.chooseImage({
      count: 9, // 默认9
      sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success: function (res) {
        let localIds = res.localIds;
        for(var i = 0; i < localIds.length; i++) {
          let currentIndex = index + i;
          that.setState((previousState)=>{
            previousState.localImages[currentIndex] = {
              url: localIds[i],
              uploading: false
            };
            return {
              localImages: previousState.localImages
            };
          });
        }
        syncUpload(localIds,index+localIds.length-1);
      }
    });
  }
  postMedia() {
    if(!this.state.handleSubmiting){
      this.setState({handleSubmiting:true});
      MediaActions.postMedia({
        type: this.state.type,
        district: this.state.countryTab === 'foreign' ? 1 : 0,
        images: this.state.images,
        // vr: {url: '', cover: ''},
        // video: {url: '', cover: ''},
        desc: this.state.desc,
        // title: this.state.title,
        price: this.state.price,
        free: this.state.price === 0 ? true : false,
        from: this.state.from,
        city_id: this.state.city_id,
        category_id: this.state.category_id,
        hidden_desc: this.state.hidden_desc,
        hidden_url: this.state.hidden_url,
        formatted_address: this.state.formatted_address,
        name: this.state.name,
        lat: this.state.lat,
        lng: this.state.lng,
        viewport: this.state.viewport,
        bounds: this.state.bounds,
        types: this.state.types,
        reviews: this.state.reviews,
        rating: this.state.rating,
        price_level: this.state.price_level,
        url: this.state.url,
        vicinity: this.state.vicinity,
        website: this.state.website,
        accessToken: UserStore.getState().accessToken
      });
      MediaActions.refreshMediaList();
    }
  }
  handleTextChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }
  onCityFocus() {
    this.setState({step: 'citySearch'});
  }
  onLocationFocus() {
    this.setState({step: 'locationSearch'});
  }
  onCityInputChange(event) {
    if(this.state.inputTimeout) {
      clearTimeout(this.state.inputTimeout);
    }
    let key = event.target.value;
    let that = this;
    let searchCity = function() {
      fetch(`${API.getCityList}&key=${key}`)
        .then(res=>res.json())
        .then(json=>{
          that.setState({cities: json.result});
        });
    }
    this.setState({inputTimeout: setTimeout(searchCity, 1000)});
  }
  onLocationInputChange(event) {
    if(this.state.inputTimeout) {
      clearTimeout(this.state.inputTimeout);
    }
    let key = event.target.value;
    let that = this;
    let searchLocation = function() {
      fetch(`${API.getLocationSearch}&key=${key}`)
        .then(res=>res.json())
        .then(json=>{
          var result = JSON.parse(json);
          if(result.predictions){
            that.setState({locations: result.predictions});
          }
        });
    }
    this.setState({inputTimeout: setTimeout(searchLocation, 1000)});
  }
  pickCity(city) {
    this.setState({
      city_id: city._id,
      step: 2,
      city_name: city.name
    });
  }
  pickLocation(location){
    fetch(`${API.getPlace}&placeid=${location.place_id}`)
        .then(res=>res.json())
        .then(json=>{
          var place = JSON.parse(json).result;
          this.setState({
            place_id: place.place_id,
            step: 1,
            title: place.name,
            formatted_address: place.formatted_address,
            name: place.name,
            lat: place.geometry.location.lat,
            lng: place.geometry.location.lng,
            viewport: place.geometry.viewport,
            bounds: place.geometry.bounds,
            types: place.types,
            reviews: place.reviews,
            rating: place.rating,
            price_level: place.price_level,
            url: place.url,
            vicinity: place.vicinity,
            website: place.website
          });        
        });
  }
  onFromChange(e) {
    this.setState({from: e.target.value});
  }
  togglePriceInputReveal(price, e) {
    if(this.state.priceInputRevealShow) {
      this.setState({priceInputRevealShow: false});
    } else {
      this.setState({price: 1, priceInputRevealShow: true, isOtherPrice: true});
    }
  }
  toggleAdditionInputReveal(e) {
    if(this.state.additionInfoRevealShow){
      this.setState({
        additionInfoRevealShow: false
      });
    }else{
      this.setState({additionInfoRevealShow: true});
    }
  }
  toggleErrorMsgReveal(e){
    this.setState({
      errorMsg: ''
    });
  }
  render() {
    let step;
    let pictureUpload;
    if(API.isWechat){
      pictureUpload = ( 
        <div className="add-pic" onClick={this.wechatPicUpload}>
          <i className="fa fa-plus" aria-hidden="true"></i>
        </div> 
      );
    }else{
      pictureUpload = ( 
        <div className="add-pic">
          <input className="pic-input" onChange={this.picUpload} type="file" multiple="multiple" name="pic" />
          <i className="fa fa-plus" aria-hidden="true"></i>
        </div>
      );
    }
    if(this.state.step === 1) {
      step = (
        <div className="step-1">
          <div className="country-tab text-center button-group">
            <a className={this.state.countryTab === 'inner' ? 'active button' : 'button'} onClick={this.changeCountryTabInner}>国内</a>
            <a className={this.state.countryTab === 'foreign' ? 'active button' : 'button'} onClick={this.changeCountryTabForeign}>国外</a>
          </div>

          <input type="text" name="title" onFocus={this.onLocationFocus} readOnly value={this.state.title} onChange={this.handleTextChange} placeholder="必填（地名如：罗浮宫）" />
          
          <div className="row text-center button-group categories">
            {this.state.categories.map(cat=>
              <a onClick={this.onCategoryClick.bind(this, cat._id)} className="columns small-4 button" key={cat._id}>{cat.name}</a>
            )}
              <a onClick={this.onCategoryClick.bind(this, '')} className="columns small-4 button" key="other">其他</a>
          </div>
          <div className="row pics">
            {this.state.localImages.map((img, ind) => {
              let bgImg = {
                backgroundImage: `url(${img.url})`
              };
              return (
                <div className={`pic-container ${img.uploading?'uploading':""}`} key={ind}>
                  <img src={img.url} className='pic' style={bgImg} />
                  <i onClick={this.removePicture.bind(this,img)} key={'i-'+ind} className="remove fa fa-minus-circle" aria-hidden="true"></i>
                </div>
              );
            })}
            {pictureUpload} 
            <div className="text-gray fz-12 alert">(最多选9张图)</div>
          </div>
          <div className="go-step-2 columns">
            <button className="button expanded" onClick={this.goStep2} disabled={this.state.localImages.reduce((p, v)=> {if(p==='disabled'){return p}else{return v.uploading ? 'disabled' : ''}}, '')}>下一步</button>
          </div>
        </div>
      );
    } else if(this.state.step === 2) {
      let priceInputRevel;
      if(this.state.priceInputRevealShow){
        priceInputRevel = (
          <div className="reveal-overlay">
            <div className="reveal">
              <input className="mt-15" type="number" placeholder="金额：¥1～150" value={this.state.price} onChange={this.onPriceInput} />
              <button className="expanded button mb-0" onClick={this.togglePriceInputReveal}>确定</button>
            </div>
          </div>
        );
      }
      let additionInfoReveal;
      if(this.state.additionInfoRevealShow){
        additionInfoReveal = (
          <div className="reveal-overlay">
            <div className="reveal text-center">
              <p>增加奇趣含金量</p>
              <textarea className="mt-15 hidden-desc" value={this.state.hidden_desc} onChange={this.handleTextChange} name="hidden_desc" placeholder="重要信息(叫什么名字或怎么到达)"></textarea>
              <input className="mt-15" type="text" name="hidden_url" value={this.state.hidden_url} placeholder="超链接(怎么买或百科)" onChange={this.handleTextChange} />
              <button className="expanded addition-info button mb-0" onClick={this.toggleAdditionInputReveal}>确定</button>
            </div>
          </div>
        );
      }
      let errorMsgReveal;
      if(this.state.errorMsg){
        errorMsgReveal=(
          <div className="text-center error-msg" >
            <button className="close-btn" onClick={this.toggleErrorMsgReveal} aria-label="Close alert" type="button">
              <span aria-hidden="true">×</span>
            </button>
            {this.state.errorMsg}
          </div>
        );
      }
      step = (
        <div className="step-2">
          {priceInputRevel}
          {additionInfoReveal}
          <textarea className="desc" name='desc' onChange={this.handleTextChange} placeholder="一次只说一个奇趣小地方" value={this.state.desc}></textarea>
          <input type="text" name="city" onFocus={this.onCityFocus} placeholder="必填（城市如：悉尼）" readOnly value={this.state.city_name} />
          <input type="text" placeholder="图片来源（选填）" value={this.state.from} onChange={this.onFromChange}/>
          <div className="price text-center">
            <p>不白白分享奇趣小地方</p>
            <div className="row price-btns">
              <div className="columns small-4">
                <button className={this.state.price === 1 && !this.state.isOtherPrice ? 'expanded button active' : 'expanded button'} onClick={this.onPriceClick.bind(this, 1)}>¥ 1</button>
              </div>
              <div className="columns small-4">
                <button className={this.state.price === 2 ? 'expanded button active' : 'expanded button'} onClick={this.onPriceClick.bind(this, 2)}>¥ 2</button>
              </div>
              <div className="columns small-4">
                <button className={this.state.price === 0 ? 'expanded button active' : 'expanded button'} onClick={this.onPriceClick.bind(this, 0)}>免费</button>
              </div>
              <div className="columns small-12 text-center">
                <button onClick={this.togglePriceInputReveal} className={this.state.isOtherPrice ? 'button active' : 'button'}>其他金额{this.state.isOtherPrice ? `：¥ ${this.state.price}` : '' }</button>
              </div>
            </div>
            <p className="text-gray fz-12 text-left" style={{marginBottom:'5px'}}>需要付钱才能查看你的小地方名称，坐标，地址等隐藏信息。收入 80 ％归你，自动入库微信钱包</p>
            <p className="text-gray fz-12 text-left">非原创内容请注明来源；未授权内容请征得原创作者同意后再发布； 请遵守 <a href="https://shimo.im/doc/fA3jr6G9JqAREkmX?r=EQ27L/" target="_blank" style={{color:"#2199e8"}}>小地球用户协议</a></p>
          </div>
          <div className="extra-hidden text-center">
            <button className="button expanded extra-button" onClick={this.toggleAdditionInputReveal}>点击添加可选隐藏信息</button>
          </div>
          {errorMsgReveal}
          <div className="text-center row">
            <div className="columns small-6">
              <button className="button expanded go-step-1" onClick={this.goStep1}>上一步</button>
            </div>
            <div className="columns small-6">
              <button className="button expanded submit" onClick={this.postMedia} disabled={this.state.handleSubmiting?true:false}>
               {this.state.handleSubmiting?"发射中":"发射"}
              </button>
            </div>
          </div>
        </div>
      );
    } else if(this.state.step === 'citySearch') {
      step = (
        <div className="city-search row">
          <div className="columns">
            <p className="text-gray fz-12 mb-0">不清楚城市名称可直接输入国家名称</p>
            <input type="text" autoFocus placeholder="必填（城市如：悉尼）" onChange={this.onCityInputChange} />
          </div>
          <ul className="accordion columns cities">
            {this.state.cities.map(city=>{
              return (
                <li className="accordion-item city" key={city._id} onClick={this.pickCity.bind(this, city)}>
                  <span className="accordion-title">{city.name}</span>
                </li>
              );
            })}
          </ul>
          <div className="columns back">
            <button className="expanded button" onClick={this.goStep2}>返回</button>
          </div>
        </div>
      );
    } else if(this.state.step === 'locationSearch') {
      step = (
        <div className="city-search row">
          <div className="columns">
            <p className="text-gray fz-12 mb-0">境外地址请尽可能使用英文名称搜索,确保搜索结果</p>
            <input type="text" autoFocus placeholder="必填（地名如：罗浮宫）" onChange={this.onLocationInputChange} />
          </div>
          <ul className="accordion columns cities">
            {this.state.locations.map(location=>{
              return (
                <li className="accordion-item city" key={location.place_id} onClick={this.pickLocation.bind(this, location)}>
                  <span className="accordion-title">{location.description}</span>
                </li>
              );
            })}
          </ul>
          <div className="columns back">
            <button className="expanded button" onClick={this.goStep1}>返回</button>
          </div>
        </div>
      );
    }
    let footer;
    if(this.state.step === 'citySearch' || this.state.step === "locationSearch") {
      footer = null;
    } else {
      footer = (<div className="cancel columns">
        <button className="button expanded" onClick={() => {browserHistory.goBack()}}>取消</button>
      </div>)
    }
    return (
      <div className="publish-component">
        {step}
        {footer}
      </div>
    );
  }
}

PublishComponent.displayName = 'PublishComponent';

// Uncomment properties you need
// PublishComponent.propTypes = {};
// PublishComponent.defaultProps = {};

export default PublishComponent;



// WEBPACK FOOTER //
// ./src/components/PublishComponent.js